import { motion } from "framer-motion";

export const Preloader = () => (
    <motion.div
        data-testid="preloader"
        className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-ink"
        exit={{ y: "-100%", transition: { duration: 0.9, ease: [0.76, 0, 0.24, 1] } }}
    >
        <motion.p
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="mb-4 font-mono text-[10px] uppercase tracking-[0.4em] text-zinc-500 md:text-xs"
        >
            Chennai, Tamil Nadu — India
        </motion.p>
        <motion.img
            src="/logo.png"
            alt="SVS Balaji Industries logo"
            data-testid="preloader-logo"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            className="mb-6 h-20 w-20 md:h-24 md:w-24"
        />
        <div className="overflow-hidden">
            <motion.p
                initial={{ y: "110%" }}
                animate={{ y: "0%" }}
                transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                className="font-display text-4xl uppercase tracking-tight text-zinc-100 md:text-6xl"
            >
                SVS <span className="text-ember">Balaji</span>
            </motion.p>
        </div>
        <motion.div
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 1.3, ease: "easeInOut" }}
            className="mt-6 h-px w-48 origin-left bg-ember"
        />
    </motion.div>
);
